import React from 'react';
//import {NavLink} from 'react-router-dom';

const AR = function(){
 return(
     <div>
        <h2>Augmented Reality</h2>
        <h3>Facetracking</h3>
        <p>Using MindAR I was able to track positions on your face. Here is a <a href="https://charlesbrandt.8thwall.app/face-effect-demo/">demo</a>.</p>
        <h3>Text to Speech</h3>
        <p>When I was digging around in the documentation at Mozilla I found that text-to-speech functionality was built in to modern JavaScript. This could be a useful way to give commands to an AR app so I have created a <a href="./xr/textToSpeech.html">demonstration of its functionality</a>.</p>
        <h3>Device sensors</h3>
        <p>Modern JavaScript offers support for the device sensors built into smartphones, tablets, etc. These sensors provide opportunities to create new ways of interacting with AR. These sensors are not consistently present on all devices. That is why I created a page to allow you to check what sensors are available on your device. <a href="./xr/sensorCheck.html">Test your sensors on this page.</a></p>
     </div>
 );
}

export default AR;